"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ContactUser = /** @class */ (function () {
    function ContactUser() {
    }
    //showMaxAttachmentsExceeded() {
    //    this.service.showError("You must be premium user to add more than 2 attachments")
    //}
    ContactUser.prototype.ngOnInit = function () {
    };
    return ContactUser;
}());
exports.ContactUser = ContactUser;
